<template>
  <div class="top-selling" v-lazy:background-image="background">
    <Information />
    <Options
      :options="options"
      v-on:selected="selected = $event"
      :active="active"
    />
    <Showcase :image="selected.image" />
  </div>
</template>

<script>
import Information from "@/components/top-selling/Information.vue";
import Options from "@/components/top-selling/Options.vue";
import Showcase from "@/components/top-selling/Showcase.vue";

import options from "@/data/top-selling";
import background from "@/assets/top-selling/background.jpg";
import backgroundL from "@/assets/top-selling/background-l.jpg";

export default {
  name: "TopSelling",
  components: {
    Information,
    Options,
    Showcase
  },
  data() {
    return {
      selected: options[0],
      background: {
        src: background,
        loading: backgroundL
      },
      options
    };
  },
  computed: {
    active() {
      return this.selected ? this.selected.key : -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.top-selling {
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;

  padding: 1rem;

  display: grid;
  grid-template-columns: 40% 60%;
  grid-template-rows: 1fr 5fr;
  grid-template-areas:
    "information options"
    "information showcase";
}
@media screen and (max-width: 1366px) {
  .top-selling {
    grid-template-columns: 100%;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: "options" "showcase" "information";
  }
}
</style>
